import React, { useState } from 'react';
import {
  FiChevronDown,
  FiChevronUp,
  FiMail,
  FiUsers,
  FiMessageSquare,
  FiList
} from 'react-icons/fi';
import {
  ForwardContainer,
  ForwardHeader,
  ForwardMeta,
  ForwardContent,
  ToggleExpand,
  RecipientsList,
  RecipientItem,
  ForwardedItemsList,
  ForwardedItem
} from './styles';
import { MdSubdirectoryArrowRight } from 'react-icons/md';
import { useSmartScroll } from 'hooks/useSmartScroll';

export function ForwardedCommentBox({
  forwards,
  forwardItems,
  scrollOffset = 80,
  hightlightTarget = true
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  // Use custom scroll hook
  const scrollToElement = useSmartScroll({
    offset: scrollOffset,
    Highlight: hightlightTarget,
    highlightColor: '#d7dbe2'
  });

  if (!forwards || forwards.length === 0) return null;

  const toggleExpand = (e) => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  const handleScroll = (id) => {
    scrollToElement(id);
  };

  const totalRecipients = forwards.reduce(
    (total, forward) => total + forward.recipients.length,
    0
  );
  const totalForwardedComments = forwards.reduce(
    (total, forward) => total + forward.items.length,
    0
  );

  return (
    <ForwardContainer>
      <ForwardHeader>
        <FiMail style={{ marginRight: '6px', verticalAlign: 'middle' }} />
        Encaminhado para:
      </ForwardHeader>

      <ForwardMeta>
        <span>
          {totalRecipients} destinatário{totalRecipients > 1 ? 's' : ''}
        </span>

        {totalForwardedComments > 0 && (
          <>
            {' • '}
            <span>{totalForwardedComments} comentários</span>
          </>
        )}
      </ForwardMeta>

      <ForwardContent className={isExpanded ? 'expanded' : ''}>
        {forwards.map((forward, index) => (
          <div
            key={forward.id}
            style={{ marginBottom: index < forwards.length - 1 ? '16px' : '0' }}
          >
            {/* Recipients */}
            <div style={{ marginBottom: '8px' }}>
              <strong
                style={{
                  fontSize: '0.8rem',
                  color: '#525f7f',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <FiUsers style={{ marginRight: '4px' }} />
                Destinatários ({forward.recipients.length}):
              </strong>
              <RecipientsList>
                {forward.recipients.map((recipient, idx) => (
                  <RecipientItem key={idx}>{recipient}</RecipientItem>
                ))}
              </RecipientsList>
            </div>

            {/* Forwarded Comments */}
            {forwardItems && forwardItems.length > 0 && (
              <div>
                <strong
                  style={{
                    fontSize: '0.8rem',
                    color: '#525f7f',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <FiMessageSquare style={{ marginRight: '4px' }} />
                  Comentários encaminhados ({forwardItems.length}):
                </strong>
                <ForwardedItemsList>
                  {forwardItems.map((item, idx) => {
                    return (
                      <>
                        {idx > 0 && (
                          <MdSubdirectoryArrowRight
                            style={{
                              marginLeft: `${idx - 0.9}rem`,
                              marginTop: '10px'
                            }}
                          />
                        )}
                        <ForwardedItem
                          key={item.id}
                          mf={idx}
                          onClick={() => handleScroll(item.id)}
                          dangerouslySetInnerHTML={{
                            __html:
                              item?.description ||
                              `<i>Comentário não encontrado</i>`
                          }}
                        />
                      </>
                    );
                  })}
                </ForwardedItemsList>
              </div>
            )}
          </div>
        ))}

        {forwards[0].include_full_history && forwards[0].items.length === 0 && (
          <div>
            <strong
              style={{
                fontSize: '0.8rem',
                color: '#525f7f',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <FiList style={{ marginRight: '4px' }} />
              Encaminhamento de histórico
            </strong>
          </div>
        )}
      </ForwardContent>

      <ToggleExpand onClick={toggleExpand}>
        {isExpanded ? (
          <span>
            <FiChevronUp
              style={{ verticalAlign: 'middle', marginRight: '4px' }}
            />
            Ver menos
          </span>
        ) : (
          <span>
            <FiChevronDown
              style={{ verticalAlign: 'middle', marginRight: '4px' }}
            />
            Ver mais detalhes
          </span>
        )}
      </ToggleExpand>
    </ForwardContainer>
  );
}
